import { Component } from '@angular/core';
import { DtoAgentVM } from '../../../Model/agents/DtoAgentVM';
import { environment } from '../../../../environments/environment'
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from '../../../Shared/Services/auth.service';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { GalleryService } from '../../../Services/gallery.service';
import { Router } from '@angular/router';
import { ViewGalleryComponent } from '../view-gallery/view-gallery.component';
import { DialogService } from '../../../Shared/Services/dialog.service';

@Component({
  selector: 'app-galleries-list',
  templateUrl: './galleries-list.component.html',
  styleUrl: './galleries-list.component.scss'
})
export class GalleriesListComponent {
  AllGalleriesForWorkshop: DtoAgentVM[] = [];
  OriginalGalleries: DtoAgentVM[] = [];
  imgPath: string = environment.ImgUrl;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  constructor(private auth: AuthService, private router: Router, private dialogService: DialogService,
    private api: GalleryService, private spinner: NgxSpinnerService) { }

  ngOnInit() {
    if (this.auth.isAuthenticated()) {
      this.spinner.show();
      this.GetGalleriesForWorkshop();
    }
    else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  GetGalleriesForWorkshop() {
    if (this.auth.isAuthenticated()) {
      this.api.GetGalleriesForWorkshop()
        .pipe(takeUntil(this.destroy$))
        .subscribe((res: any) => {
          this.AllGalleriesForWorkshop = res.payload;
          this.OriginalGalleries = res.payload;
          this.spinner.hide();
        });
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  GetFilteredList(event: any) {
    this.AllGalleriesForWorkshop = [];
    if (event.list?.length > 0) {
      this.AllGalleriesForWorkshop = event.list;
    }
  }

  EditGallery(id?: number) {
    this.router.navigateByUrl('dashboard/edit-gallery/' + id);
  }

  ViewGallery(id?: number) {
    const data = { 'selectedGalleryId': id };
    this.dialogService.openDialog(ViewGalleryComponent, data);
  }
}
